module.exports = __webpack_public_path__ + "static/media/fly0224.f78a8317.webp";